import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=68972fbb&scoped=true&"
import script from "./SelectDropdown.vue?vue&type=script&lang=ts&"
export * from "./SelectDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SelectDropdown.vue?vue&type=style&index=0&id=68972fbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68972fbb",
  null
  
)

export default component.exports